// extracted by mini-css-extract-plugin
export default {"token":"bK32rK","focus":"cK32rK","disabled":"dK32rK"};